<template>
    <div class="model-config-container">
        <div @click="goback" class="back-btn">
            <i class="el-icon-back"></i>
            返回
        </div>

        <!-- 模块导航 -->
        <div class="tabs-wrapper">
            <el-tabs v-model="activeTab" class="config-tabs" type="card">
                <el-tab-pane label="基础信息" name="basic">
                    <div class="tab-content basic-content">
                        <el-button class="tab-actions" type="primary" size="small" @click="Validate(onSubmit)">{{
                            submitbutton }}</el-button>
                        <el-form ref="form" :model="form" :rules="rules" label-width="140px" class="basic-form"
                            size="small">
                            <div class="form-section">
                                <div class="form-section-title">基本信息</div>
                                <el-form-item prop="modelConfig.schema" label="APP选择">
                                    <el-select v-model="form.modelConfig.schema" placeholder="下拉选择" filterable>
                                        <el-option v-for="item in schemalist" :key="item.code" :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="model" label="内部型号">
                                    <el-input v-model="form.model"></el-input>
                                </el-form-item>
                                <el-form-item prop="name" label="外部型号">
                                    <el-input v-model="form.name"></el-input>
                                </el-form-item>
                                <el-form-item label="默认名称">
                                    <el-input v-model="form.modelConfig.name"></el-input>
                                </el-form-item>
                                <el-form-item prop="client_brand_code" label="所属品牌">
                                    <el-select v-model="form.client_brand_code">
                                        <el-option v-for="item in brandlist" :key="item.code" :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否输入型号密钥">
                                    <el-radio-group v-model="secretType">
                                        <el-radio :label="1">手动填写</el-radio>
                                        <el-radio :label="2">自动生成</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="secretType == 1" prop="secret" label="产品型号秘钥">
                                    <el-input v-model="form.secret"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-section">
                                <div class="form-section-title">设备属性</div>
                                <el-form-item label="产品类型" prop="modelConfig.model_type">
                                    <el-radio-group v-model="form.modelConfig.model_type">
                                        <el-radio :label="1">普通设备</el-radio>
                                        <el-radio :label="2">低功耗设备</el-radio>
                                        <el-radio :label="3">灯带</el-radio>
                                        <el-radio :label="4">打猎相机</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item prop="modelConfig.level" label="产品级别">
                                    <el-radio-group v-model="form.modelConfig.level">
                                        <el-radio :label="1">相机</el-radio>
                                        <el-radio :label="2">基站</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item prop="modelConfig.network_type" label="网络类型">
                                    <el-radio-group v-model="form.modelConfig.network_type">
                                        <el-radio :label="1">WIFI</el-radio>
                                        <el-radio :label="2">4G</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="产品状态">
                                    <el-radio-group v-model="form.modelConfig.status">
                                        <el-radio :label="0">测试</el-radio>
                                        <el-radio :label="1">上架</el-radio>
                                        <el-radio :label="2">下架</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="低电量提醒阈值">
                                    <el-input-number v-model="form.modelConfig.low_battery" :min="0"></el-input-number>
                                </el-form-item>
                            </div>
                            <div class="form-section">
                                <div class="form-section-title">智能平台</div>
                                <el-form-item prop="modelConfig.category" label="alexa所属类别">
                                    <el-select v-model="form.modelConfig.category" @change="CategoryChange">
                                        <el-option v-for="item in alexList" :key="item.Code" :label="item.Name"
                                            :value="item.Code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="modelConfig.alexa_status" label="支持alexa">
                                    <el-radio-group v-model="form.modelConfig.alexa_status">
                                        <el-radio :label="1">支持</el-radio>
                                        <el-radio :label="2">不支持</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item prop="modelConfig.google_status" label="支持googlehome">
                                    <el-radio-group v-model="form.modelConfig.google_status">
                                        <el-radio :label="1">支持</el-radio>
                                        <el-radio :label="2">不支持</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item prop="modelConfig.home_kit_status" label="支持home kit">
                                    <el-radio-group v-model="form.modelConfig.home_kit_status">
                                        <el-radio :label="1">支持</el-radio>
                                        <el-radio :label="2">不支持</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item prop="modelConfig.smart_thing_status" label="支持smart_thing">
                                    <el-radio-group v-model="form.modelConfig.smart_thing_status">
                                        <el-radio :label="1">支持</el-radio>
                                        <el-radio :label="2">不支持</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                            <div class="form-section">
                                <div class="form-section-title">云存服务</div>
                                <el-form-item prop="modelConfig.free_cloud" label="支持领取免费云">
                                    <el-radio-group v-model="form.modelConfig.free_cloud">
                                        <el-radio :label="1">支持</el-radio>
                                        <el-radio :label="2">不支持</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item prop="modelConfig.free_trial" label="支持免费试用">
                                    <el-radio-group v-model="form.modelConfig.free_trial">
                                        <el-radio :label="1">支持</el-radio>
                                        <el-radio :label="2">不支持</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item prop="modelConfig.default_cloud" label="支持默认云存">
                                    <el-radio-group v-model="form.modelConfig.default_cloud">
                                        <el-radio :label="1">支持</el-radio>
                                        <el-radio :label="2">不支持</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="配网" name="pairing">
                    <div class="tab-content">
                        <ModelPairingTab v-if="activeTab === 'pairing'" :product-model="savedModel"></ModelPairingTab>
                    </div>
                </el-tab-pane>

                <!-- 功能定义模块 -->
                <el-tab-pane label="功能定义" name="functions">
                    <div class="tab-content">
                        <div class="function-header">
                            <div class="function-title">
                                <h3>功能定义</h3>
                                <p class="function-desc">从物模型中选择需要的功能点，配置设备的功能定义</p>
                            </div>
                            <el-button type="primary" size="small" @click="openFunctionDialog">
                                <i class="el-icon-edit"></i>
                                添加/编辑功能
                            </el-button>
                        </div>

                        <div class="function-list" v-if="selectedFunctions.length > 0">
                            <el-table :data="selectedFunctions" border class="function-table" size="small">
                                <el-table-column label="ID" prop="id" width="60" align="center"></el-table-column>
                                <el-table-column label="标识符" prop="identifier" width="180"></el-table-column>
                                <el-table-column label="功能名称" prop="name" width="180">
                                    <template v-slot="scope">
                                        <span>{{ scope.row.name || scope.row.desc }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="数据类型" prop="data_type" width="100" align="center">
                                    <template v-slot="scope">
                                        <el-tag :type="getDataTypeColor(scope.row.data_type)" size="small">
                                            {{ getDataTypeName(scope.row.data_type) }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="读写类型" width="100" align="center">
                                    <template v-slot="scope">
                                        <el-tag :type="scope.row.writable ? 'success' : 'info'" size="small">
                                            {{ scope.row.writable ? '可读写' : '只读' }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="是否必需" width="80" align="center">
                                    <template v-slot="scope">
                                        <el-tag :type="scope.row.required ? 'warning' : ''" size="small">
                                            {{ scope.row.required ? '必需' : '可选' }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="功能点属性" min-width="200" align="left">
                                    <template v-slot="scope">
                                        <div class="specs-display">
                                            <span v-if="scope.row.data_type === 'enum'">
                                                <el-tag v-for="(value, key) in scope.row.specs" :key="key" size="mini"
                                                    style="margin-right: 5px;">
                                                    {{ key }}: {{ value }}
                                                </el-tag>
                                                <el-tag size="mini">默认值: {{ scope.row.default }}</el-tag>
                                            </span>
                                            <span v-else style="white-space: pre-line;">
                                                {{ formatDataStruct(scope.row.data_type, scope.row.specs, scope.row.default)
                                                }}
                                            </span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" prop="desc" min-width="100"></el-table-column>
                                <el-table-column label="操作" width="120" align="center">
                                    <template v-slot="scope">
                                        <el-button type="text" size="small" :disabled="scope.row.unmatched"
                                            @click="editFunction(scope.row)">
                                            修改默认值
                                        </el-button>
                                        <el-button type="text" size="small" style="color: #f56c6c;"
                                            @click="removeFunction(scope.$index)">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <div v-else class="empty-functions">
                            <div class="empty-content">
                                <i class="el-icon-document-add"></i>
                                <p>暂无功能定义</p>
                                <p class="empty-desc">点击"添加/编辑功能"从物模型中选择功能点</p>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 关联套餐模块 -->
                <el-tab-pane label="设备能力" name="capability">
                    <div class="tab-content">
                        <CapabilityTab v-if="activeTab === 'capability'" :product-model="savedModel"
                            :model-type="form.modelConfig.model_type" :network-type="form.modelConfig.network_type">
                        </CapabilityTab>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="关联套餐" name="packages">
                    <div class="tab-content">
                        <div class="package-header">
                            <h3>关联套餐</h3>
                            <el-button type="primary" size="mini" @click="relatePack">
                                <i class="el-icon-plus"></i>
                                编辑关联套餐
                            </el-button>
                        </div>
                        <!-- 已有套餐 -->
                        <el-table border v-bind:data="modelpackList" size="small" class="package-table">
                            <el-table-column label="套餐名称" min-width="240" show-overflow-tooltip>
                                <template v-slot="scope">
                                    <span>{{ scope.row.SetMeal.name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="套餐时长" min-width="100" align="center">
                                <template v-slot="scope">
                                    <span>{{
                                        scope.row.SetMeal.time +
                                        '(' +
                                        scope.row.SetMeal.time_unit +
                                        ')'
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="套餐价格" min-width="90" align="center">
                                <template v-slot="scope">
                                    <span>{{ scope.row.SetMeal.price }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="套餐售价" min-width="90" align="center">
                                <template v-slot="scope">
                                    <span>{{ scope.row.SetMeal.saleprice }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="币种" min-width="70" align="center">
                                <template v-slot="scope">
                                    <span>{{ scope.row.SetMeal.currency }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="服务等级" min-width="180" align="center">
                                <template v-slot="scope">
                                    <span>{{
                                        scope.row.SetMeal.level === 1
                                            ? 'Starter'
                                            : scope.row.SetMeal.level === 2
                                                ? 'Standard'
                                                : scope.row.SetMeal.level === 3
                                                    ? 'Pro'
                                                    : scope.row.SetMeal.level === 4 ? 'Generative AI Services' : ''
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="套餐状态" min-width="90" align="center">
                                <template v-slot="scope">
                                    <span>{{
                                        scope.row.SetMeal.status == 0
                                            ? '测试'
                                            : scope.row.SetMeal.status == 1
                                                ? '上架'
                                                : scope.row.SetMeal.status == 2
                                                    ? '下架'
                                                    : scope.row.SetMeal.status == 3
                                                        ? '已删除'
                                                        : '未知'
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="周期" min-width="70" align="center">
                                <template v-slot="scope">
                                    <span>{{ scope.row.SetMeal.cycles }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="事件存储" min-width="90" align="center">
                                <template v-slot="scope">
                                    <span>{{
                                        scope.row.SetMeal.is_event == 0
                                            ? '否'
                                            : scope.row.SetMeal.is_event == 1
                                                ? '是'
                                                : '未知'
                                    }}</span>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="套餐到期时间">
            <template v-slot="scope">
              <span>{{ changeTime(scope.row.SetMeal.expire) }}</span>
            </template>
          </el-table-column> -->
                        </el-table>
                        <el-pagination @current-change="handlemodelpackChange" v-model:currentPage="modelpackSearch.page"
                            :page-size="modelpackSearch.limit" layout="total, prev, pager, next" :total="modelpacktotal">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!-- 功能选择弹窗 -->
        <el-dialog title="选择功能" v-model="functionDialogVisible" width="1200px" class="function-dialog">
            <!-- 快捷复制：把其他型号的功能（含默认值）合并到已选，确认后随保存一起提交 -->
            <div class="copy-bar">
                <span class="copy-label">从其他型号复制</span>
                <el-select v-model="copySourceCode" filterable remote clearable size="small" style="width: 320px;"
                    placeholder="输入型号或名称搜索" :remote-method="searchCopyModels" :loading="copyModelLoading">
                    <el-option v-for="item in copyModelOptions" :key="item.code"
                        :label="`${item.model}${item.name ? '（' + item.name + '）' : ''}`" :value="item.code">
                    </el-option>
                </el-select>
                <el-radio-group v-model="copyMode" size="small">
                    <el-radio label="merge">合并到已选</el-radio>
                    <el-radio label="replace">替换已选</el-radio>
                </el-radio-group>
                <el-button type="primary" size="small" plain :disabled="!copySourceCode" :loading="copying"
                    @click="copyFromModel">复制</el-button>
            </div>
            <div class="dialog-content">
                <div class="left-panel">
                    <div class="panel-header">
                        <h4>可选功能 ({{ availableFunctions.length }})</h4>
                        <el-button type="text" size="small" @click="selectAllFunctions"
                            v-if="availableFunctions.length > 0">全部添加</el-button>
                    </div>
                    <div class="function-search">
                        <el-input v-model="functionSearchKeyword" placeholder="搜索功能名称或标识符"
                            prefix-icon="el-icon-search" size="small" clearable></el-input>
                    </div>
                    <div class="standard-functions">
                        <div v-if="availableFunctions.length === 0" class="empty-selected">
                            <p>{{ functionSearchKeyword ? '没有匹配的功能' : '已全部添加' }}</p>
                        </div>
                        <div v-for="func in availableFunctions" :key="func.identifier" class="function-item"
                            @click="toggleFunction(func)">
                            <div class="function-info">
                                <div class="function-name">{{ func.desc }}</div>
                                <div class="function-details">
                                    <span class="function-id">ID: {{ func.id }}</span>
                                    <span class="function-identifier">标识符: {{ func.identifier }}</span>
                                </div>
                                <div class="function-type" v-if="func.data_type">
                                    <el-tag :type="getDataTypeColor(func.data_type)" size="mini">
                                        {{ getDataTypeName(func.data_type) }}
                                    </el-tag>
                                    <el-tag :type="func.writable ? 'success' : 'info'" size="mini">
                                        {{ func.writable ? '可读写' : '只读' }}
                                    </el-tag>
                                </div>
                            </div>
                            <div class="function-action">
                                <i class="el-icon-plus" style="color: #409eff;"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="right-panel">
                    <div class="panel-header">
                        <h4>已选功能 ({{ selectedTempFunctions.length }})</h4>
                        <el-button type="text" size="small" @click="clearSelectedFunctions"
                            v-if="selectedTempFunctions.length > 0">
                            清空
                        </el-button>
                    </div>
                    <div class="standard-functions selected-list">
                        <div v-if="selectedTempFunctions.length === 0" class="empty-selected">
                            <p>未选择任何功能</p>
                        </div>
                        <div v-for="func in selectedTempFunctions" :key="func.identifier" class="function-item"
                            @click="toggleFunction(func)">
                            <div class="function-info">
                                <div class="function-name">{{ func.desc }}</div>
                                <div class="function-details">
                                    <span class="function-id">ID: {{ func.id }}</span>
                                    <span class="function-identifier">标识符: {{ func.identifier }}</span>
                                </div>
                                <div class="function-type" v-if="func.data_type">
                                    <el-tag :type="getDataTypeColor(func.data_type)" size="mini">
                                        {{ getDataTypeName(func.data_type) }}
                                    </el-tag>
                                    <el-tag :type="func.writable ? 'success' : 'info'" size="mini">
                                        {{ func.writable ? '可读写' : '只读' }}
                                    </el-tag>
                                </div>
                            </div>
                            <div class="function-action">
                                <i class="el-icon-close" style="color: #f56c6c;"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template #footer>
                <div class="dialog-footer">
                    <el-button size="small" @click="functionDialogVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="confirmAddFunctions">
                        保存 ({{ selectedTempFunctions.length }})
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 默认值编辑抽屉：型号只保存"标识符 + 默认值"，功能点属性来自物模型，这里只读展示 -->
        <el-drawer title="修改默认值" v-model="editDialogVisible" direction="rtl" size="600px" class="edit-drawer"
            custom-class="flex-drawer">
            <div class="drawer-layout">
                <div class="drawer-content">
                    <el-form :model="editForm" label-width="100px" size="small">
                        <el-form-item label="功能点名称">{{ editForm.desc }}</el-form-item>
                        <el-form-item label="标识符">{{ editForm.identifier }}</el-form-item>
                        <el-form-item label="数据类型">
                            <el-tag :type="getDataTypeColor(editForm.data_type)" size="small">
                                {{ getDataTypeName(editForm.data_type) }}
                            </el-tag>
                        </el-form-item>
                        <el-form-item label="读写类型">
                            <el-tag :type="editForm.writable ? 'success' : 'info'" size="small">
                                {{ editForm.writable ? '可读写' : '只读' }}
                            </el-tag>
                        </el-form-item>
                        <el-form-item label="功能点属性">
                            <div v-if="isOptionType(editForm.data_type)">
                                <el-tag v-for="(value, key) in editForm.specs" :key="key" size="small" class="enum-tag">
                                    {{ key }}：{{ value }}
                                </el-tag>
                            </div>
                            <pre v-else class="specs-preview">{{ formatSpecsPreview(editForm.specs) }}</pre>
                            <div class="form-tip">功能点属性来自物模型，如需修改请到物模型管理</div>
                        </el-form-item>
                        <el-form-item label="默认值">
                            <el-select v-if="isOptionType(editForm.data_type)" v-model="editForm.default"
                                placeholder="选择默认值">
                                <el-option v-for="(value, key) in editForm.specs" :key="key" :label="`${key}：${value}`"
                                    :value="key">
                                </el-option>
                            </el-select>
                            <el-input-number v-else-if="editForm.data_type === 'int'" v-model="editForm.default"
                                :min="(editForm.specs || {}).min" :max="(editForm.specs || {}).max"
                                :step="(editForm.specs || {}).step || 1">
                            </el-input-number>
                            <el-input v-else-if="isJsonType(editForm.data_type)" type="textarea" :rows="8"
                                v-model="editForm.default" placeholder="请输入 JSON 格式的默认值">
                            </el-input>
                            <el-input v-else v-model="editForm.default" :maxlength="(editForm.specs || {}).length"
                                placeholder="请输入默认值">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 当前 element-plus 版本的 el-drawer 不支持 footer 插槽，按钮放在内容里 -->
                <div class="drawer-footer">
                    <el-button size="small" @click="editDialogVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="saveEditFunction">保存</el-button>
                </div>
            </div>
        </el-drawer>

        <el-dialog title="型号套餐关联" v-model="dialogFormVisible" width="1200px">
            <!-- 快捷复制：把其他型号已关联的套餐追加到当前型号，立即生效，不会取消已有关联 -->
            <div class="copy-bar">
                <span class="copy-label">从其他型号复制</span>
                <el-select v-model="packCopySourceCode" filterable remote clearable size="small" style="width: 320px;"
                    placeholder="输入型号或名称搜索" :remote-method="searchCopyModels" :loading="copyModelLoading">
                    <el-option v-for="item in copyModelOptions" :key="item.code"
                        :label="`${item.model}${item.name ? '（' + item.name + '）' : ''}`" :value="item.code">
                    </el-option>
                </el-select>
                <el-button type="primary" size="small" plain :disabled="!packCopySourceCode" :loading="packCopying"
                    @click="copyPacksFromModel">复制关联套餐</el-button>
                <span class="help-text">只追加当前型号未关联的套餐（跳过已删除套餐），不会取消已有关联</span>
            </div>
            <el-form ref="form" style="flex:1" :inline="true" :model="packSearch" class="demo-form-inline" size="mini">
                <el-form-item>
                    <el-input v-model.trim="packSearch.kname" placeholder="模糊搜索名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="packSearch.status" multiple placeholder="状态集合">
                        <el-option label="测试" :value="0"></el-option>
                        <el-option label="上架" :value="1"></el-option>
                        <el-option label="下架" :value="2"></el-option>
                        <el-option label="已删除" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="packSearch.is_event" clearable placeholder="是否为事件">
                        <el-option label="否" :value="0"></el-option>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="全部" :value="-1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="packSearch.currency" clearable placeholder="币种">
                        <el-option v-for="item in currencylist" :key="item.code" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="packSearch.region" clearable placeholder="区域">
                        <el-option label="cn" value="cn"></el-option>
                        <el-option label="eu" value="eu"></el-option>
                        <el-option label="us" value="us"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="Searchpack">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table border v-bind:data="packList" @sort-change="Sortchange" size="mini">
                <el-table-column label="套餐名称" sortable width="260">
                    <template v-slot="scope">
                        <span>{{ scope.row.SetMeal.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐时长" sortable>
                    <template v-slot="scope">
                        <span>{{
                            scope.row.SetMeal.time +
                            '(' +
                            scope.row.SetMeal.time_unit +
                            ')'
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐价格" sortable>
                    <template v-slot="scope">
                        <span>{{ scope.row.SetMeal.price }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐售价" width="80">
                    <template v-slot="scope">
                        <span>{{ scope.row.SetMeal.saleprice }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="币种" sortable width="70">
                    <template v-slot="scope">
                        <span>{{ scope.row.SetMeal.currency }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐状态" width="70">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.SetMeal.status == 0
                                ? '测试'
                                : scope.row.SetMeal.status == 1
                                    ? '上架'
                                    : scope.row.SetMeal.status == 2
                                        ? '下架'
                                        : scope.row.SetMeal.status == 3
                                            ? '已删除'
                                            : '未知'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="服务等级" width="70">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.SetMeal.level === 1
                                ? 'Starter'
                                : scope.row.SetMeal.level === 2
                                    ? 'Standard'
                                    : scope.row.SetMeal.level === 3
                                        ? 'Pro'
                                        : scope.row.SetMeal.level === 4 ? 'Generative AI Services' : ''
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="文件时长(天)" sortable width="120">
                    <template v-slot="scope">
                        <span>{{ scope.row.SetMeal.file_time }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="事件存储 ">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.SetMeal.is_event == 0
                                ? '否'
                                : scope.row.SetMeal.is_event == 1
                                    ? '是'
                                    : '未知'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="区域" width="60">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.SetMeal.region }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="套餐到期时间">
          <template v-slot="scope">
            <span>{{ changeTime(scope.row.SetMeal.expire) }}</span>
          </template>
        </el-table-column> -->
                <el-table-column label="操作" width="70">
                    <template v-slot="scope">
                        <input type="checkbox" :checked="scope.row.SetMealProductModel.id !== 0"
                            :ref="'check' + scope.row.SetMeal.code" @change="checkchange(scope.row)" />
                    </template>
                </el-table-column>
            </el-table>
            <div style="height: 40px">
                <el-pagination @current-change="handleCurrentChange" v-model:currentPage="packSearch.page"
                    :page-size="packSearch.limit" layout="total, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
import api from "../../../axios/pack"

import util from "../../../util/util"
import ModelPairingTab from "../pairing/ModelPairingTab.vue"
import CapabilityTab from "../pairing/CapabilityTab.vue"
export default {
    name: "",
    mixins: [],
    components: { ModelPairingTab, CapabilityTab },
    props: {},
    data() {
        return {
            secretType: 2,
            form: {
                code: "",
                client_product_code: "",
                model: "",
                name: "",
                secret: "",
                category_code: "",
                client_brand_code: "",
                set_network_codes: [],
                category_panel_code: "",
                modelConfig: {
                    model_type: "",
                    number: "",
                    status: 0,
                    config: "{}",
                    level: "",
                    low_battery: 1,
                    category: "",
                    alexa_status: 2,
                    google_status: 2,
                    home_kit_status: 2,
                    smart_thing_status: 2,
                    schema: "",
                    name: "",
                    free_cloud: 2,
                    free_trial: 1,
                    default_cloud: 2,
                    network_type: ""
                },
            },
            modelCode: "",
            ProCode: "",
            brandCode: "",
            submitbutton: "",
            currencylist: [],
            rules: {
                code: [{ required: true, message: "请输入记录编号", trigger: "blur" }],
                // client_product_code: [{ required: false, message: '请输入产品编号', trigger: 'blur' }],
                model: [{ required: true, message: "请输入产品型号", trigger: "blur" }],
                name: [
                    { required: true, message: "请输入产品型号名称", trigger: "blur" },
                ],
                // secret: [{ required: true, message: '请输入产品型号秘钥', trigger: 'blur' }],
                "modelConfig.status": [
                    { required: true, message: "请输入产品状态", trigger: "blur" },
                ],
                "modelConfig.schema": [
                    { required: true, message: "请选择schema", trigger: "blur" },
                ],
                "modelConfig.model_type": [
                    { required: true, message: "请输入产品类型", trigger: "blur" },
                ],
                // 'modelConfig.number': [{ required: true, message: '请输入产品唯一编号', trigger: 'blur' }],
                "modelConfig.config": [
                    {
                        required: true,
                        message: "请输入产品默认json配置",
                        trigger: "blur",
                    },
                ],
                "modelConfig.level": [
                    { required: true, message: "请输入产品级别", trigger: "blur" },
                ],
                // 'modelConfig.category': [{ required: true, message: '请输入alexa所属类别', trigger: 'blur' }],
                "modelConfig.alexa_status": [
                    { required: true, message: "请输入支持alexa", trigger: "blur" },
                ],
                "modelConfig.google_status": [
                    { required: true, message: "请输入支持googlehome", trigger: "blur" },
                ],
            },
            //
            prolist: [],
            jsonConfig: "",
            packSearch: {
                page: 1,
                limit: 10,
                kname: "",
                code: "",
                product_model_code: "",
                status: [0, 1],
                is_event: -1,
                currency: '',
                order_field: "",
                order_action: 1,
                region: ''
            },
            packList: [],
            total: 0,
            dialogFormVisible: false,
            // 已分配套餐
            modelpackList: [],
            modelpacktotal: 0,
            modelpackSearch: {
                page: 1,
                limit: 10,
                kname: "",
                code: "",
                product_model_code: "",
            },
            schemalist: [],
            netlist: [],
            brandlist: [],
            panellist: [],
            categorylist: [],
            alexList: [],
            // 新增的数据
            activeTab: 'basic',
            // 已保存的内部型号：配网、设备能力按它存取，避免用表单里尚未保存的输入
            savedModel: '',
            // 功能定义相关
            selectedFunctions: [], // 已选择的功能列表
            functionDialogVisible: false,
            editDialogVisible: false,
            editForm: {
                identifier: '',
                desc: '',
                data_type: '',
                writable: false,
                specs: {},
                default: null
            },
            functionSearchKeyword: '',
            // 从其他型号复制功能
            copySourceCode: '',
            copyMode: 'merge',
            copyModelOptions: [],
            copyModelLoading: false,
            copying: false,
            packCopySourceCode: '',
            packCopying: false,
            selectedTempFunctions: [], // 弹窗中的选择，打开时以型号当前功能为初始值
            // 标准功能列表（物模型）
            standardFunctions: [],
            standardFunctionsReady: null // 物模型列表请求，型号功能需等它返回后再按标识符匹配
        }
    },
    computed: {
        // 左侧可选：物模型中未被选择且匹配搜索词的功能
        availableFunctions() {
            const keyword = this.functionSearchKeyword.trim().toLowerCase()
            return this.standardFunctions.filter(func =>
                !this.isSelected(func.identifier) &&
                (!keyword ||
                    (func.desc || '').toLowerCase().includes(keyword) ||
                    (func.identifier || '').toLowerCase().includes(keyword))
            )
        }
    },
    methods: {
        GetAllAttriubte() {
            this.standardFunctionsReady = this.api.TslAttributeList({
                rows: 2000
            }).then(res => {
                this.standardFunctions = res.data.data.data || []
            })
        },
        // 型号功能定义：接口只保存"标识符 + 默认值"，其余配置按标识符从物模型匹配
        loadModelFunctions() {
            return Promise.all([
                this.standardFunctionsReady,
                this.api.ProductModelAttributes({ model: this.modelCode })
            ]).then(([, res]) => {
                if (res.data.code != 200) {
                    this.$message.error("获取功能定义失败" + res.data.msg)
                    return
                }
                this.selectedFunctions = (res.data.data || []).map(item => this.toModelFunction(item))
            })
        },
        toModelFunction(item) {
            const std = this.standardFunctions.find(f => f.identifier === item.attribute)
            if (!std) {
                return {
                    id: '-',
                    identifier: item.attribute,
                    desc: '物模型中不存在该标识符',
                    data_type: '',
                    specs: {},
                    default: item.default,
                    unmatched: true
                }
            }
            return { ...std, default: this.parseDefault(std.data_type, item.default) }
        },
        // array/struct 的默认值提交时需要是对象
        parseDefault(type, value) {
            if (this.isJsonType(type) && typeof value === 'string') {
                try {
                    return JSON.parse(value)
                } catch (e) {
                    return value
                }
            }
            return value
        },
        // 分配接口按整份列表提交，添加和删除都提交变更后的完整列表
        saveModelFunctions(list) {
            const attributes = {}
            list.forEach(f => {
                attributes[f.identifier] = this.parseDefault(f.data_type, f.default)
            })
            return this.api.ProductModelAttributesAssign({ model: this.modelCode, attributes }).then(res => {
                if (res.data.code == 200) {
                    return true
                }
                this.$message.error("保存失败" + res.data.msg)
                return false
            })
        },
        isOptionType(type) {
            return type === 'enum' || type === 'bool'
        },
        isJsonType(type) {
            return type === 'array' || type === 'struct'
        },
        formatSpecsPreview(specs) {
            return specs && Object.keys(specs).length ? JSON.stringify(specs, null, 2) : '无'
        },
        CategoryChange(val) {
            if (val == "") {
                this.form.modelConfig.alexa_status = 2
            } else {
                this.form.modelConfig.alexa_status = 1
            }
        },
        GetCurrency() {
            this.api.CurrencyList({
                page: 1,
                limit: 100,
            }).then(res => {
                if (res.data.code == 200) {
                    this.currencylist = res.data.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        GetAlexList() {
            this.api.AlexaCategoryList({}).then((res) => {
                if (res.data.code == 200) {
                    this.alexList = res.data.data
                    this.GetCategory()
                    return
                }
                this.$message.error("获取失败" + res.data.msg)
            })
        },
        GetCategory() {
            this.api
                .CategoryList({
                    page: 1,
                    limit: 100,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.categorylist = res.data.data.data
                        this.GetPanel()
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        GetPanel() {
            this.api
                .PanelList({
                    page: 1,
                    limit: 100,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.panellist = res.data.data.data
                        this.GetBrand()
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        GetBrand() {
            this.api
                .BrandList({
                    page: 1,
                    limit: 100,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.brandlist = res.data.data.data
                        this.GetNet()
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        GetNet() {
            this.api
                .SetNetworkList({
                    page: 1,
                    limit: 100,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.netlist = res.data.data.data
                        this.GetSchema()
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        Sortchange(column) {
            switch (column.column.label) {
                case "套餐名称":
                    this.packSearch.order_field = "name"
                    break
                case "套餐时长":
                    this.packSearch.order_field = "time"
                    break
                case "套餐价格":
                    this.packSearch.order_field = "price"
                    break
                case "币种":
                    this.packSearch.order_field = "currency"
                    break
                case "文件时长(天)":
                    this.packSearch.order_field = "file_time"
                    break
            }
            this.packSearch.order_action = this.packSearch.order_action == 1 ? 2 : 1
            this.Searchpack()
        },
        GetSchema() {
            this.api
                .ClientList({
                    page: 1,
                    limit: 100,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.schemalist = res.data.data.data
                        this.GetProList()
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        // 已分配列表
        GetmodelpackList(item) {
            api
                .PackageList({
                    page: this.modelpackSearch.page,
                    limit: this.modelpackSearch.limit,
                    kname: this.modelpackSearch.kname,
                    code: this.modelpackSearch.code,
                    is_event: -1,
                    product_model_code: this.modelpackSearch.product_model_code,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.modelpackList = res.data.data.data
                        this.modelpacktotal = res.data.data.page_info.total
                        if (item == "distribute") {
                            this.Searchpack()
                        }
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        handlemodelpackChange(val) {
            this.modelpackSearch.page = val
            this.GetmodelpackList()
        },
        relatePack() {
            this.dialogFormVisible = true
            this.packCopySourceCode = ''
            if (!this.copyModelOptions.length) this.searchCopyModels('')
            this.Searchpack()
        },
        // 分页拉取某型号的全部已关联套餐
        async fetchAllModelPacks(modelCode) {
            const limit = 100
            const all = []
            for (let page = 1; ; page++) {
                const res = await api.PackageList({ page, limit, is_event: -1, product_model_code: modelCode })
                if (res.data.code != 200) throw new Error(res.data.msg)
                const rows = res.data.data.data || []
                all.push(...rows)
                if (!rows.length || all.length >= res.data.data.page_info.total) break
            }
            return all
        },
        async copyPacksFromModel() {
            if (this.modelCode === "0") {
                this.$message.warning("请先在基础信息中创建型号")
                return
            }
            this.packCopying = true
            try {
                const [source, current] = await Promise.all([
                    this.fetchAllModelPacks(this.packCopySourceCode),
                    this.fetchAllModelPacks(this.modelCode),
                ])
                const existing = new Set(current.map(item => item.SetMeal.code))
                const todo = source.filter(item => item.SetMeal.status != 3 && !existing.has(item.SetMeal.code))
                if (!todo.length) {
                    this.$message.warning(source.length ? "该型号的套餐当前型号都已关联" : "该型号还没有关联套餐")
                    return
                }
                await this.$confirm(`将为当前型号追加关联 ${todo.length} 个套餐，立即生效，确定继续?`, "提示", { type: "warning" })
                const failed = []
                // 逐个调用，避免并发写同一型号
                for (const item of todo) {
                    try {
                        const res = await api.ProPackDistriUpdate({
                            product_model_code: this.modelCode,
                            set_meal_code: item.SetMeal.code,
                        })
                        if (res.data.code != 200) failed.push(`${item.SetMeal.name}：${res.data.msg}`)
                    } catch (e) {
                        failed.push(`${item.SetMeal.name}：${e.message || e}`)
                    }
                }
                const ok = todo.length - failed.length
                if (failed.length) {
                    this.$message.error(`成功 ${ok} 个，失败 ${failed.length} 个：${failed.join("；")}`)
                } else {
                    this.$message.success(`已追加关联 ${ok} 个套餐`)
                }
                this.Searchpack()
                this.GetmodelpackList()
            } catch (e) {
                if (e !== "cancel") this.$message.error("复制关联套餐失败" + (e && e.message ? e.message : ""))
            } finally {
                this.packCopying = false
            }
        },
        handleCurrentChange(val) {
            this.packSearch.page = val
            this.Searchpack()
        },
        Searchpack(item) {
            api
                .PackageList({
                    page: this.packSearch.page,
                    limit: this.packSearch.limit,
                    kname: this.packSearch.kname,
                    code: this.packSearch.code,
                    product_model_code: this.modelCode,
                    model_action: 1,
                    status: JSON.stringify(this.packSearch.status),
                    is_event: this.packSearch.is_event,
                    currency: this.packSearch.currency,
                    order_field: this.packSearch.order_field,
                    order_action: this.packSearch.order_action,
                    region: this.packSearch.region,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.packList = res.data.data.data
                        this.total = res.data.data.page_info.total
                        if (item == "delete") {
                            this.GetmodelpackList()
                        }
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        // 分配
        checkchange(item) {
            if (item.SetMealProductModel.id == 0) {
                api
                    .ProPackDistriUpdate({
                        product_model_code: this.modelCode,
                        set_meal_code: item.SetMeal.code,
                    })
                    .then((res) => {
                        if (res.data.code == 200) {
                            this.$message.success("分配成功")
                            this.GetmodelpackList("distribute")
                            return
                        }
                        this.$message.error("分配失败" + res.data.msg)
                    })
            } else {
                api
                    .ProPackDistriDelete({
                        id: item.SetMealProductModel.id,
                    })
                    .then((res) => {
                        if (res.data.code == 200) {
                            this.$message.success("取消分配成功")
                            this.Searchpack("delete")
                            return
                        }
                        this.$message.error("取消分配失败" + res.data.msg)
                    })
            }
        },
        onJsonChange(value) {
            // 数据改变时触发
            this.jsonConfig = JSON.stringify(value)
            this.form.modelConfig.config = this.jsonConfig
        },
        GetProList() {
            this.api
                .ProductList({
                    page: 1,
                    limit: 100,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.prolist = res.data.data.data
                        this.GetmodelpackList()
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        GetConfig() {
            this.api
                .ProductModelDetail({
                    code: this.modelCode,
                })
                .then((res) => {
                    if (res.status == 200) {
                        console.log("config", JSON.parse(res.data.data.config.config))
                        this.form.modelConfig = res.data.data.config
                        this.jsonConfig = res.data.data.config.config
                        this.form.code = res.data.data.model.code
                        this.form.client_product_code =
                            res.data.data.model.client_product_code
                        this.form.model = res.data.data.model.model
                        this.savedModel = res.data.data.model.model
                        this.form.name = res.data.data.model.name
                        this.form.secret = res.data.data.model.secret
                        this.form.category_code = res.data.data.model.category_code
                        this.form.client_brand_code = res.data.data.model.client_brand_code
                        this.form.set_network_codes = JSON.parse(
                            res.data.data.model.set_network_codes
                        )
                            ? JSON.parse(res.data.data.model.set_network_codes)
                            : this.form.set_network_codes
                        this.form.category_panel_code =
                            res.data.data.model.category_panel_code
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        goback() {
            if (this.$route.params.code.split("&")[2] == "model") {
                this.$router.push("/iot/model")
            } else if (this.$route.params.code.split("&")[2] == "online") {
                this.$router.push("/iot/online")
            } else {
                this.$router.push("/iot/promodel/model/" + this.ProCode)
            }
        },
        Validate: function (call) {
            this.$refs["form"].validate((res) => {
                if (res && call) {
                    call()
                }
            })
        },
        onSubmit() {
            this.api
                .ProductModelUpdate({
                    code: this.form.code,
                    client_product_code: this.form.client_product_code,
                    model: this.form.model,
                    name: this.form.name,
                    secret: this.form.secret,
                    category_code: this.form.category_code,
                    client_brand_code: this.form.client_brand_code,
                    set_network_codes: this.form.set_network_codes,
                    category_panel_code: this.form.category_panel_code,
                    client_product_model_config_v1: {
                        model_type: +this.form.modelConfig.model_type,
                        number: this.form.modelConfig.number,
                        schema: this.form.modelConfig.schema,
                        status: +this.form.modelConfig.status,
                        name: this.form.modelConfig.name,
                        config: this.form.modelConfig.config,
                        level: +this.form.modelConfig.level,
                        low_battery: +this.form.modelConfig.low_battery,
                        category: this.form.modelConfig.category,
                        alexa_status: +this.form.modelConfig.alexa_status,
                        google_status: +this.form.modelConfig.google_status,
                        home_kit_status: +this.form.modelConfig.home_kit_status,
                        smart_thing_status: +this.form.modelConfig.smart_thing_status,
                        free_cloud: +this.form.modelConfig.free_cloud,
                        free_trial: +this.form.modelConfig.free_trial,
                        default_cloud: +this.form.modelConfig.default_cloud,
                        network_type: +this.form.modelConfig.network_type
                    },
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$message.success(this.submitbutton + "成功")
                        this.enterEditMode(res.data.data && res.data.data.code ? res.data.data.code : this.form.model)
                        return
                    }
                    this.$message.error(this.submitbutton + "失败" + res.data.msg)
                })
        },
        // 保存后进入编辑模式：新建时切到新型号的编辑页，编辑时刷新详情
        enterEditMode(code) {
            const parts = this.$route.params.code.split("&")
            if (this.modelCode !== code) {
                parts[0] = code
                // 同一路由组件会复用，不会重新 mounted，这里同步改状态；URL 用 replace，刷新后仍是编辑页
                this.$router.replace({ params: { ...this.$route.params, code: parts.join("&") } })
            }
            this.modelCode = code
            this.modelpackSearch.product_model_code = code
            this.submitbutton = "修改"
            this.GetConfig()
            this.loadModelFunctions()
            this.GetmodelpackList()
        },
        changeTime(item) {
            return util.dateFormat(item)
        },
        // 功能定义相关方法
        openFunctionDialog() {
            if (this.modelCode === "0") {
                this.$message.warning("请先在基础信息中创建型号")
                return
            }
            this.functionDialogVisible = true
            // 回显型号已有功能（保留已保存的默认值），弹窗内可增可删
            this.selectedTempFunctions = this.selectedFunctions.map(func => ({ ...func }))
            this.copySourceCode = ''
            this.copyMode = 'merge'
            if (!this.copyModelOptions.length) this.searchCopyModels('')
            this.functionSearchKeyword = ''
        },
        isSelected(identifier) {
            return this.selectedTempFunctions.some(func => func.identifier === identifier)
        },
        isAlreadyAdded(identifier) {
            return this.selectedFunctions.some(func => func.identifier === identifier)
        },
        toggleFunction(func) {
            const index = this.selectedTempFunctions.findIndex(f => f.identifier === func.identifier)
            if (index > -1) {
                this.selectedTempFunctions.splice(index, 1)
            } else {
                this.selectedTempFunctions.push({ ...func })
            }
        },
        selectAllFunctions() {
            this.selectedTempFunctions.push(...this.availableFunctions.map(func => ({ ...func })))
        },
        searchCopyModels(keyword) {
            this.copyModelLoading = true
            // 型号和名称各搜一次再合并，接口按字段分别模糊匹配
            const query = field => this.api.ProductModelList({ page: 1, limit: 20, [field]: keyword || '' })
                .then(res => (res.data.code == 200 ? res.data.data.data || [] : []))
                .catch(() => [])
            Promise.all([query('model'), query('kname')]).then(([byModel, byName]) => {
                const map = new Map()
                byModel.concat(byName).forEach(item => {
                    if (item.code !== this.modelCode) map.set(item.code, item)
                })
                this.copyModelOptions = [...map.values()]
            }).finally(() => {
                this.copyModelLoading = false
            })
        },
        copyFromModel() {
            this.copying = true
            this.api.ProductModelAttributes({ model: this.copySourceCode }).then(res => {
                if (res.data.code != 200) {
                    this.$message.error("获取型号功能失败" + res.data.msg)
                    return
                }
                const source = (res.data.data || []).map(item => this.toModelFunction(item))
                if (!source.length) {
                    this.$message.warning("该型号还没有配置功能")
                    return
                }
                if (this.copyMode === 'replace') {
                    this.selectedTempFunctions = source
                    this.$message.success(`已替换为 ${source.length} 个功能，保存后生效`)
                    return
                }
                // 合并：已选中的保留当前默认值，只追加缺少的
                const added = source.filter(f => !this.isSelected(f.identifier))
                this.selectedTempFunctions.push(...added)
                this.$message.success(`已合并 ${added.length} 个功能，保存后生效`)
            }).finally(() => {
                this.copying = false
            })
        },
        clearSelectedFunctions() {
            this.selectedTempFunctions = []
        },
        // 弹窗选择即型号的完整功能列表，整体提交
        confirmAddFunctions() {
            const list = this.selectedTempFunctions
            const added = list.filter(f => !this.isAlreadyAdded(f.identifier)).length
            const removed = this.selectedFunctions.filter(f => !this.isSelected(f.identifier)).length
            // 复制可能只改了默认值，也要提交
            const changed = list.filter(f => {
                const old = this.selectedFunctions.find(o => o.identifier === f.identifier)
                return old && JSON.stringify(old.default) !== JSON.stringify(f.default)
            }).length
            if (!added && !removed && !changed) {
                this.functionDialogVisible = false
                return
            }
            const submit = () => this.saveModelFunctions(list).then(ok => {
                if (!ok) return
                this.functionDialogVisible = false
                this.$message.success(`保存成功（新增 ${added} 个，移除 ${removed} 个${changed ? `，默认值变更 ${changed} 个` : ''}）`)
                this.loadModelFunctions()
            })
            if (!removed) {
                submit()
                return
            }
            this.$confirm(`将移除 ${removed} 个已配置的功能，确定保存吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(submit).catch(() => { })
        },
        removeFunction(index) {
            this.$confirm('确定要删除这个功能定义吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const rest = this.selectedFunctions.filter((f, i) => i !== index)
                return this.saveModelFunctions(rest).then(ok => {
                    if (!ok) return
                    this.$message.success('删除成功')
                    this.loadModelFunctions()
                })
            })
        },
        editFunction(row) {
            let value = row.default
            if (this.isJsonType(row.data_type)) {
                value = value === undefined || value === null ? '' : JSON.stringify(value, null, 2)
            } else if (row.data_type === 'int') {
                value = value === '' || value === undefined || value === null ? undefined : Number(value)
            } else if (value !== undefined && value !== null) {
                value = String(value)
            }
            this.editForm = { ...row, specs: row.specs || {}, default: value }
            this.editDialogVisible = true
        },
        saveEditFunction() {
            const { identifier, data_type } = this.editForm
            let value = this.editForm.default
            if (this.isJsonType(data_type)) {
                try {
                    value = JSON.stringify(JSON.parse(value))
                } catch (e) {
                    this.$message.warning('默认值不是合法的 JSON')
                    return
                }
            } else {
                value = value === undefined || value === null ? '' : String(value)
            }
            this.api.ProductModelAttributesDefault({
                model: this.modelCode,
                attribute: identifier,
                value
            }).then(res => {
                if (res.data.code == 200) {
                    this.editDialogVisible = false
                    this.$message.success('修改成功')
                    this.loadModelFunctions()
                    return
                }
                this.$message.error('修改失败' + res.data.msg)
            })
        },
        getDataTypeName(type) {
            const typeMap = {
                'bool': '布尔型',
                'int': '数值型',
                'enum': '枚举型',
                'text': '字符型',
                'array': '数组型',
                'struct': '对象型'
            }
            return typeMap[type] || type
        },
        getDataTypeColor(type) {
            const colorMap = {
                'bool': 'primary',
                'int': 'primary',
                'enum': 'warning',
                'text': 'primary',
                'array': 'success',
                'struct': 'success',
            }
            return colorMap[type] || ''
        },
        formatIntSpecs(specs) {
            if (!specs) return ''
            const parts = []
            if (specs.min !== undefined) parts.push(`最小值: ${specs.min}`)
            if (specs.max !== undefined) parts.push(`最大值: ${specs.max}`)
            if (specs.step !== undefined) parts.push(`步长: ${specs.step}`)
            if (specs.unit) parts.push(`单位: ${specs.unit}`)
            if (specs.scale !== undefined) parts.push(`精度: ${specs.scale}`)
            return parts.join(', ')
        },
        formatArraySpecs(specs, defaultVal) {
            if (!specs) return ''
            let str = this.formatDataStruct(specs.item.type, specs.item.specs, defaultVal)
            str += `\n最大长度: ${specs.size}`
            return str
        },
        formatStructSpecs(specs, defaultVal) {
            if (!specs) return ''
            let str = ''
            specs.forEach((ele, i) => {
                const val = this.formatDataStruct(ele.dataType.type, ele.dataType.specs)
                const showVal = val === '' ? '' : `（${val}）`
                str += `${i === 0 ? '' : '\n'}${ele.name}${showVal}`
            })
            str += `\n默认值: ${JSON.stringify(defaultVal)}`
            return str
        },
        formatTextSpecs(specs) {
            if (!specs) return ''
            const parts = []
            if (specs.default !== undefined) parts.push(`默认值: ${specs.default === '' ? '空' : specs.default} `)
            if (specs.length !== undefined) parts.push(`最大长度: ${specs.length} `)
            return parts.length > 0 ? parts.join(', ') : '文本类型'
        },
        formatEnumSpecs(specs, defaultVal) {
            if (!specs) return ''
            const enumValues = Object.entries(specs).map(([k, v]) => `${k}:${v} `).join(', ')
            return `${enumValues}, 默认值: ${defaultVal !== '' ? defaultVal : '无'}`
        },
        formatBoolSpecs(specs, defaultVal) {
            if (!specs) return ''
            const enumValues = Object.entries(specs).map(([k, v]) => `${k}:${v} `).join(', ')
            return `${enumValues}, 默认值: ${defaultVal !== '' ? defaultVal : '无'}`
        },
        formatDataStruct(type, specs, defaultVal) {
            if (!type) return ''
            switch (type) {
                case 'bool':
                    return this.formatBoolSpecs(specs, defaultVal)
                case 'int':
                    return this.formatIntSpecs(specs, defaultVal)
                case 'enum':
                    return this.formatEnumSpecs(specs, defaultVal)
                case 'text':
                    return this.formatTextSpecs(specs, defaultVal)
                case 'array':
                    return this.formatArraySpecs(specs, defaultVal)
                case 'struct':
                    return this.formatStructSpecs(specs, defaultVal)
                default:
                    return type
            }
        }
    },
    filters: {},
    mounted() {
        this.modelCode = this.$route.params.code.split("&")[0]
        this.modelpackSearch.product_model_code = this.modelCode
        this.brandCode = this.$route.params.code.split("&")[1]
        console.log(this.$route.params, 99999)
        console.log(this.brandCode, 99999)

        if (this.brandCode) {
            this.form.client_brand_code = this.brandCode
        }
        if (this.modelCode !== "0") {
            this.submitbutton = "修改"
            this.GetConfig()
            this.loadModelFunctions()
        } else {
            this.submitbutton = "创建"
        }
    },
    created() {
        this.GetAlexList()
        this.GetCurrency()
        this.GetAllAttriubte()
    },
}
</script>

<style scoped>
.tabs-wrapper {
    position: relative;
}

.specs-preview {
    margin: 0;
    max-height: 240px;
    overflow: auto;
    font-size: 12px;
    line-height: 18px;
    color: #606266;
    white-space: pre-wrap;
}

.form-tip {
    font-size: 12px;
    line-height: 18px;
    color: #909399;
}

/* 关联套餐表格：单元格不换行，套餐名称超长时省略并悬浮提示 */
.package-table ::v-deep(.cell) {
    white-space: nowrap;
}

/* 按钮放在基础信息内容区右上角，与分组标题同一行 */
.basic-content {
    position: relative;
}

.tab-actions {
    position: absolute;
    top: 4px;
    right: 0;
    z-index: 1;
}

.back-btn {
    font-size: 14px;
    margin-bottom: 8px;
    cursor: pointer;
    width: 60px;
    color: #409eff;
    display: flex;
    align-items: center;
    gap: 5px;
}

.back-btn:hover {
    color: #66b1ff;
}

.config-tabs {
    background: white;
}

/* el-tabs__header 是 el-tabs 内部元素，scoped 下必须用 v-deep 才能稳定命中 */
.config-tabs ::v-deep(.el-tabs__header) {
    margin: 0 0 15px;
    border-bottom: 1px solid #e4e7ed;
}

/* .config-tabs .el-tabs__nav-wrap {
    padding: 0 15px;
} */

.config-tabs .el-tabs__item {
    padding: 0 15px;
    height: 36px;
    line-height: 36px;
}

/* .tab-content {
    padding: 12px 0 0;
} */

.basic-form {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
    max-width: 1200px;
}

.basic-form .el-form-item {
    margin-bottom: 14px;
}

.basic-form .form-section {
    min-width: 0;
}

.basic-form .form-section-title {
    margin: 0 0 10px;
    padding-left: 8px;
    border-left: 3px solid #409eff;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    color: #303133;
}


.basic-form .el-form-item__label {
    font-size: 13px;
}

/* 功能定义样式 */
.function-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
}

.function-title h3 {
    margin: 0 0 3px 0;
    color: #303133;
    font-size: 16px;
    font-weight: 500;
}

.function-desc {
    margin: 0;
    color: #909399;
    font-size: 13px;
}

.function-table {
    margin-bottom: 10px;
}

.function-table .el-table__header th {
    padding: 8px 0;
    font-size: 13px;
}

.function-table .el-table__body td {
    padding: 8px 0;
}

.specs-display {
    line-height: 1.4;
    font-size: 12px;
    text-align: left;
}

.empty-functions {
    text-align: center;
    padding: 40px 20px;
    color: #909399;
}

.empty-content i {
    font-size: 36px;
    color: #c0c4cc;
    margin-bottom: 15px;
}

.empty-content p {
    margin: 8px 0;
    font-size: 14px;
}

.empty-desc {
    font-size: 12px !important;
    color: #c0c4cc !important;
}

/* 套餐模块样式 */
.package-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.package-header h3 {
    margin: 0;
    color: #303133;
    font-size: 16px;
    font-weight: 500;
}

/* 弹窗样式 */
::v-deep(.el-dialog__body) {
    padding: 16px;
}

.copy-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
    padding: 8px 12px;
    background: #fafafa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
}

.copy-label {
    font-size: 13px;
    color: #606266;
}

.copy-bar .help-text {
    font-size: 12px;
    color: #909399;
}

.dialog-content {
    display: flex;
    height: 500px;
    gap: 10px;
}

.left-panel,
.right-panel {
    flex: 1;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
}

.panel-header {
    padding: 8px 12px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fafafa;
}

.panel-header h4 {
    margin: 0;
    font-size: 13px;
    color: #303133;
    font-weight: 500;
}

.function-search {
    padding: 8px 12px;
    border-bottom: 1px solid #e4e7ed;
}

.standard-functions {
    flex: 1;
    overflow-y: auto;
    padding: 6px;
}

.function-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    margin-bottom: 4px;
    border: 1px solid #e4e7ed;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s;
}

.function-item:hover {
    border-color: #409eff;
    background: #f0f9ff;
}

.function-info {
    flex: 1;
}

.function-name {
    font-weight: 500;
    color: #303133;
    margin-bottom: 3px;
    font-size: 13px;
}

.function-details {
    font-size: 11px;
    color: #909399;
    margin-bottom: 5px;
}

.function-details span {
    margin-right: 12px;
}

.function-type .el-tag {
    margin-right: 5px;
}

.function-action {
    font-size: 18px;
}

/* 已选列表与可选列表同样式，仅 hover 提示移除 */
.selected-list .function-item:hover {
    border-color: #f56c6c;
    background: #fef0f0;
}

.empty-selected {
    text-align: center;
    padding: 20px 10px;
    color: #c0c4cc;
    font-size: 12px;
}

/* 编辑抽屉样式 */

/* 抽屉内容区可滚动，底部按钮固定 */
.drawer-layout {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.drawer-content {
    flex: 1;
    overflow: auto;
    padding: 0 20px;
}

.drawer-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 15px 20px;
    border-top: 1px solid #e4e7ed;
}

.edit-drawer .el-form-item {
    margin-bottom: 20px;
}

.edit-drawer .el-form-item__label {
    font-size: 13px;
    color: #606266;
}

/* 枚举值编辑器 */
.enum-editor {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
}

.enum-editor .el-tag {
    margin-bottom: 8px;
}

.enum-tag {
    border-radius: 16px;
    padding: 0 12px;
    height: 32px;
    line-height: 30px;
}

.enum-add-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 14px;
    border: 1px dashed #dcdfe6;
    border-radius: 16px;
    color: #606266;
    cursor: pointer;
    transition: all 0.2s;
}

.enum-add-btn:hover {
    border-color: #409eff;
    color: #409eff;
}

.enum-input {
    display: inline-flex;
    gap: 6px;
    align-items: center;
}

.enum-input .el-input__inner {
    height: 32px;
    line-height: 32px;
    border-radius: 16px;
    border: 1px dashed #dcdfe6;
}

.enum-input .el-input__inner:focus {
    border-style: solid;
}

.enum-default-select {
    min-width: 220px;
}

/* 布尔型编辑器 */
.bool-editor {
    padding: 10px 0;
}

/* 数值范围编辑器 */
.value-range-editor {
    display: flex;
    align-items: center;
}

/* 数组长度编辑器 */
.array-length-editor {
    display: flex;
    align-items: center;
}

/* 数组枚举配置 */
.array-enum-config {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
}

.array-enum-item {
    display: inline-block;
}

.array-enum-add {
    display: flex;
    align-items: center;
    margin-top: 8px;
}

/* 对象结构编辑器 */
.struct-editor {
    width: 100%;
}

.struct-editor .el-textarea {
    width: 100%;
}

/* 文本长度编辑器 */
.text-length-editor {
    display: flex;
    align-items: center;
}

/* 上报频率编辑器 */
.report-frequency {
    display: flex;
    align-items: center;
}

/* 响应式 */
@media (max-width: 1200px) {
    .dialog-content {
        flex-direction: column;
        height: auto;
    }

    .left-panel,
    .right-panel {
        height: 300px;
    }
}
</style>

<style>
/* el-drawer__body 是 flex:1 子项，默认 min-height:auto 会被内容撑高，抽屉又是 overflow:hidden，导致无法滚动。
   限制其高度后由内部 .drawer-content 滚动；抽屉通过 custom-class 命中，不影响其他页面 */
.flex-drawer .el-drawer__body {
    min-height: 0;
    overflow: hidden;
}
</style>
